export const secDocs = {
  name: 'sec',
  category: 'Trigonometry',
  syntax: [
    'sec(x)'
  ],
  description: 'Compute the secant of x in radians. Defined as 1/cos(x)',
  examples: [
    'sec(2)',
    '1 / cos(2)'
  ],
  seealso: [
    'cot',
    'csc',
    'cos'
  ]
}
